/**
 * Construcción del enlace de descarga por token de email (MVP-05).
 *
 * El endpoint `GET /digital-download/<token>/` lo sirve la API, que en
 * producción vive en un dominio distinto al frontend
 * (`https://api.informaticarupestre.com` vs `https://informaticarupestre.com`).
 * Por eso el enlace NO puede construirse con `window.location.origin`: hay que
 * usar la base efectiva de la API (`VITE_APP_API_BASE_URL` / `axios.defaults.baseURL`).
 *
 * Función pura y sin dependencias de entorno para poder probarla de forma
 * aislada (`downloadUrl.test.js`).
 *
 * @param {string} apiBase Base de la API (con o sin barra final).
 * @param {string} token   Token opaco hexadecimal.
 * @returns {string} URL absoluta terminada en `/digital-download/<token>/`.
 */
export function buildDownloadUrl(apiBase, token) {
    const base = String(apiBase || "").replace(/\/+$/, "");
    const safeToken = encodeURIComponent(String(token || ""));
    return `${base}/digital-download/${safeToken}/`;
}
